/* eslint-disable react/prop-types */ /* eslint-disable import/prefer-default-export */ /* eslint-disable no-unused-vars */ import React from 'react';import { useTranslation } from 'react-i18next';
import {
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
} from '@material-ui/core';

import Loading from '../../../components/loading/Loading';

export default function UpdateStatus({
  openUpdate,
  setOpenUpdate,
  loadingUpdate,
  handleUpdate,
}) {
  const { t } = useTranslation();

  return (
    <Dialog
      onClose={() => setOpenUpdate(false)}
      open={openUpdate}
      fullWidth
      maxWidth="sm"
    >
      <Loading
        open={loadingUpdate}
        msg={t('receivables.updateDialog.loading')}
      />
      <DialogTitle id="simple-dialog-title">
        {t('receivables.updateDialog.title')}
      </DialogTitle>
      <DialogContent>
        <Grid
          container
          spacing={4}
          style={{
            justifyContent: 'center',
          }}
        >
          <Grid item xs={12} sm={8}>
            <p
              style={{
                fontSize: '20px',
                textAlign: 'justify',
              }}
            >
              {`${t('receivables.updateDialog.message')}`}
            </p>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          style={{ height: 40 }}
          onClick={() => setOpenUpdate(false)}
          variant="text"
          color="primary"
        >
          {t('receivables.createDialog.buttons.cancel')}
        </Button>
        <Button
          // style={{ height: 40, backgroundColor: 'red', color: 'white' }}
          onClick={handleUpdate}
          variant="contained"
          disabled={loadingUpdate}
          color="primary"
        >
          {t('receivables.updateDialog.buttons.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
